// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-i"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 5V19M12 5H9.5M12 5H14.5M12 19H14.5M12 19H9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersIIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-i',
    ref,
    icon: element,
  },
));

LettersIIcon.displayName = 'LettersIIcon';

export default LettersIIcon;
